<template>
  <img
    :key="training"
    :src="verso"
    alt="Verso do certificado"
    class="bg-image"
  />
</template>

<script setup>
import { appStore } from "@/store";
import { computed } from "vue";

const training = computed(() => appStore.getters.getTrainingSelected);
const verso = require(`./../assets/verso/${training.value?.value} verso.png`);
</script>

<style scoped>
.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
</style>
